
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/giveback",
      function () {
        return require("private-next-pages/de/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/giveback"])
      });
    }
  